import { render, staticRenderFns } from "./LoginWaiterView.vue?vue&type=template&id=6ed4e059&"
import script from "./LoginWaiterView.vue?vue&type=script&lang=js&"
export * from "./LoginWaiterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports